export { HasMetadataResolver } from './HasMetadataResolver';
export { HasTagsResolver } from './HasTagsResolver';
